import { Injectable } from '@angular/core';
import { Confirmation, ConfirmationService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  constructor(private readonly confirmationService: ConfirmationService) {}

  confirm(options: Confirmation): void {
    this.confirmationService.confirm(options);
  }

  confirmDelete(message: string, accept: () => void): void {
    this.confirmationService.confirm({
      message,
      header: 'Confirm Delete',
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: 'p-button-danger',
      accept,
    });
  }
}
